import React, {useCallback} from "react";
import {useIsMobile} from "modules/utils/hooks";
import {GameContainer} from "components/Common";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import logoAsset from "assets/images/logos/logoWhite.png";
import {setIsTutorialViewed, toggleTutorialModal} from "modules/actions";
import {useDispatch, useSelector} from "react-redux";
import {handleMenuAnalyticsClick} from "modules/utils/helpers";
import {MenuSection} from "modules/enums";
import {NavLink} from "react-router-dom";
import {getIsSummaryShouldBeShown} from "modules/selectors";
import {createFanHubEvent, EventGUID} from "modules/utils/Services/analytics";

const Wrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 12px;

	a {
		font-style: normal;
		font-weight: 600;
		font-size: 18px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: ${({theme}) => theme.colors.text.white};
		min-width: 150px;

		@media (max-width: 1024px) {
			min-width: unset;
			padding: 0 14px;
		}

		&:hover,
		&:active,
		&:focus,
		&.active {
			cursor: pointer;
			color: ${({theme}) => theme.colors.brand.primary};
		}

		img {
			max-height: 54px;
			height: 100%;
			width: auto;
		}
	}
`;

const MenuLink = styled.a`
	font-style: normal;
	font-weight: 600;
	font-size: 18px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${({theme}) => theme.colors.text.white};
	min-width: 150px;

	&:hover,
	&:active,
	&:focus,
	&.active {
		cursor: pointer;
		color: ${({theme}) => theme.colors.brand.primary};
	}

	img {
		max-height: 54px;
		height: 100%;
		width: auto;
	}
`;

export const DesktopMenu: React.FC = () => {
	const dispatch = useDispatch();
	const {t} = useTranslation();
	const {isMobile} = useIsMobile("(max-width: 720px)");
	// const mlbContestId = useSelector(getContestExternalId);
	const homeUrl = useSelector(getIsSummaryShouldBeShown) ? "/summary" : "";

	// const navigate = useNavigate();
	// const userId = useSelector(getCurrentUserId);

	const openTutorial = useCallback(() => {
		handleMenuAnalyticsClick(MenuSection.HowToPlay);
		createFanHubEvent(EventGUID.HelpPageLoad);
		dispatch(setIsTutorialViewed(true));
		dispatch(toggleTutorialModal(true));
	}, [dispatch]);

	if (isMobile) {
		return null;
	}

	return (
		<GameContainer>
			<Wrapper>
				<NavLink
					to={homeUrl}
					onClick={() => {
						createFanHubEvent(EventGUID.NavigationHomepage);
					}}>
					<img src={logoAsset} alt="MLB BTN" />
				</NavLink>
				<MenuLink onClick={openTutorial}>{t("header.menu.tutorial")}</MenuLink>
				<NavLink
					to="/leaderboards"
					onClick={() => {
						createFanHubEvent(EventGUID.NavigationLeaderboard);
					}}>
					{t("header.menu.leaderboards")}
				</NavLink>
				<NavLink
					to="/profile"
					// onClick={() => {
					// 	createFanHubEvent(EventGUID.LeaderboardProfilePageLoad);
					// }}
				>
					{t("header.menu.user_profile", "User profile")}
				</NavLink>
			</Wrapper>
		</GameContainer>
	);
};
